module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "header"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top menu"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('h3', {
    staticClass: "header-logo-name",
    staticStyle: {
      "margin-top": "-2px",
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse navvy",
    attrs: {
      "id": "bs-example-navbar-collapse-1"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right main-menu"
  }, [_vm._m(1), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/cart"
    }
  }, [_vm._v("Cart")])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/orders"
    }
  }, [_vm._v("My Orders")])]) : _vm._e(), _vm._v(" "), (!_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Log In")])]) : _c('li', [_c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Log Out")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#bs-example-navbar-collapse-1",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "m_black"
  }, [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("About Us")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-472279ac"}!./src/pages/MainHeader/template.html
// module id = 194
// module chunks = 1